/* global jQuery, FWP */
( ( $ ) => {

    const $pattern = $('.pattern--type-18', document);
    const $filterHeading = $('.filter-heading', $pattern);
    
    const $filterBox = $('.filter-box', document);
    const $filterButton = $('.filter-button', document);
    const $closeButton = $('.close-button', $filterBox);
    const $modalBackground = $('.modal-background', document);

    // hide sub-menu
    $('.facetwp-type-fselect', $filterHeading).toggle();
    
    // Accordion JS for Filter box
    $('.accordion-trigger', $filterHeading).on('click', (event) => {
        const $this = $(event.currentTarget);
        const $icon = $this.find('.fas');
        
      // show / hide sub-menu
      $this.next('.facetwp-type-fselect').eq(0).slideToggle();

      

      $icon.toggleClass('fa-chevron-down fa-chevron-up');

    });
    
    // Filter flyout menu for mobile - Change height to match device/browser height
    
    phr_reposition_filter_box = () => {
        let top = 0;
        let height = 0;
        const $header = $('.site-header', document).eq(0);
        const $windowHeight = $(window).height();
            

            if ($header.length) {
                top += $header.outerHeight();
                height = $(window).outerHeight() - top;
            }
        
        if (window.matchMedia('(max-width: 992px)').matches) {
            $filterBox.css('top', top);
            $filterBox.css('height', height);
            $modalBackground.css('top', top);
        } else {
            return;
        }

    }
    
    
    // Filter flyout menu for mobile
    $filterButton.on('click', (event) => {
        
            event.preventDefault();
            phr_reposition_filter_box();    
    
            $filterBox.addClass( "show" );
            $modalBackground.addClass( "show" );
            });
    
    $closeButton.on('click', (event) => {
        event.preventDefault();
        $filterBox.removeClass( "show" );
        $modalBackground.removeClass( "show" );
        $filterBox.css('height', 'auto');
    });
    
   $modalBackground.on('click', (event) => {
      event.preventDefault();
        $filterBox.removeClass( "show" );
        $modalBackground.removeClass( "show" );
       $filterBox.css('height', 'auto');
    });
    
    
    
    
    $( window ).on( 'resize orientationchange', phr_reposition_filter_box );
	/*$( window ).on( 'scroll', phr_reposition_filter_box );*/

    
} )( jQuery );

